"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importDefault(require("react"));
const MenuItem_1 = tslib_1.__importDefault(require("./MenuItem"));
const getMenuItems = (items, closeMenu, onMouseEnter) => {
    return items.map((item, index) => ((0, jsx_runtime_1.jsx)(MenuItem_1.default, Object.assign({}, item, { index: index, closeMenu: closeMenu, onMouseEnter: onMouseEnter }), index)));
};
exports.default = getMenuItems;
